import Vue from "vue";
import App from "./components/App.vue";
import router from "./router";
import './assets/sass/app.scss'
import Buefy from 'buefy'
import { i18n } from './i18n.js'
import VueProgressBar from 'vue-progressbar'

Vue.use(VueProgressBar, {
  	color: '#0000CC',
  	failedColor: 'red',
  	height: '50px'
})

Vue.use(Buefy, {
    defaultContainerElement: '#content',
})

Vue.config.productionTip = false;

const app = new Vue({
  	router, i18n,
  	render: h => h(App)
}).$mount("#app");

router.beforeEach((to, from, next) => {

	if (to.name || to.path) {
		app.$Progress.start()
	}

  	next()
})

router.afterEach(() => {
  	app.$Progress.finish()
})